import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useExperiences } from 'core/contexts/experienceV2';
import { Button, Grid2, Typography } from '@mui/material';
import { Add, Backpack, SentimentVeryDissatisfied } from '@mui/icons-material';

const ExperienceNoData = () => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_list.no_data.${key}`);

    const history = useHistory();
    const handleAdd = () => history?.push('/experience/add');

    const { allExperiencesCount, resetFilters } = useExperiences();

    const buttonStyles = {
        padding: '8px',
        minWidth: '48px',
        backgroundColor: allExperiencesCount > 0 ? '#fff' : 'var(--color-utriper-blue)',
        borderColor: allExperiencesCount > 0 ? '#13131340' : '',
        color: allExperiencesCount > 0 ? '#131313' : '#fff',
        textTransform: 'none',
        fontWeight: 500,
    };

    return (
        <Grid2 container mt="32px" flexDirection="column" justifyContent="center" alignItems="center" gap="12px">
            {allExperiencesCount > 0 ? <Backpack sx={{ fontSize: 72, color: 'var(--color-utriper-blue)' }} /> : <SentimentVeryDissatisfied sx={{ fontSize: 72, color: 'var(--color-utriper-blue)' }} />}
            <Grid2 container flexDirection="column" justifyContent="center" alignItems="center" gap="8px">
                <Typography fontSize={20} fontWeight={700} textAlign="center" sx={{ color: '#131313' }}>
                    {allExperiencesCount > 0 ? translate('title.not_found') : translate('title.no_experiences')}
                </Typography>
                <Typography fontSize={16} fontWeight={500} textAlign="center" sx={{ color: '#131313bf' }}>
                    {allExperiencesCount > 0 ? translate('subtitle.not_found') : translate('subtitle.no_experiences')}
                </Typography>
            </Grid2>
            <Button sx={buttonStyles} variant={allExperiencesCount > 0 ? 'outlined' : 'contained'} startIcon={allExperiencesCount <= 0 ? <Add sx={{ color: '#fff', fontSize: '24px' }} /> : false} onClick={allExperiencesCount > 0 ? resetFilters : handleAdd}>
                {allExperiencesCount > 0 ? translate('button.clean') : translate('button.add_experience')}
            </Button>
        </Grid2>
    );
};

export default ExperienceNoData;
